import { Card, CardContent, Typography } from "@altimateai/lego";
import { Spinner, Stack } from "@altimateai/lego";
import { Tooltip } from "@altimateai/lego";
import { InfoGray } from "@assets/icons";
import { cn } from "@/lib/utils";

export type SummaryCardItem = {
  key: string;
  label: string;
  value: number | string;
  info?: string;
};

const colorList: string[] = [
  "al-bg-[#247efe]",
  "al-bg-[#ff754c]",
  "al-bg-[#ffce73]",
  "al-bg-[#01cd8c]",
  "al-bg-[#ff73e9]",
];

const SummaryCards = ({
  summary,
  isLoading = false,
  selectedKey = "",
  onClick = () => {},
}: {
  summary: SummaryCardItem[];
  isLoading?: boolean;
  selectedKey?: string;
  onClick?: (key: string) => void;
}) => {
  return isLoading ? (
    <Card className={"al-min-h-32"}>
      <CardContent>
        <Stack direction="column" align="center" justify="center" className="al-py-6">
          <Spinner />
        </Stack>
      </CardContent>
    </Card>
  ) : (
    <Stack
      id={"summary-cards"}
      aria-label="summary-cards"
      className={"al-w-full"}
      align={"center"}
      gap={"md"}
    >
      {summary.map((item, i) => (
        <Card
          className={cn(
            "al-grow al-cursor-pointer",
            selectedKey === item.key ? "al-border-action-brand" : "al-shadow-sm"
          )}
          key={item.key}
          aria-label={item.label}
          onClick={() => onClick(item.key)}
        >
          <CardContent className="!al-p-4">
            <Stack gap={"lg"}>
              <div className={cn(colorList[i % 5], "al-w-1 al-min-h-full al-rounded")}></div>
              <Stack direction={"column"} gap={"sm"} className={"al-py-2"}>
                <Stack gap={"sm"} align={"center"}>
                  <Typography
                    className={"al-text-muted-foreground"}
                    variant={"body"}
                    size={"xs"}
                    weight={"regular"}
                  >
                    {item.label}
                  </Typography>
                  {item?.info && (
                    <Tooltip title={item.info}>
                      <Stack align="center">
                        <InfoGray />
                      </Stack>
                    </Tooltip>
                  )}
                </Stack>
                <Typography variant={"h4"} weight={"semibold"}>
                  {item.value}
                </Typography>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export default SummaryCards;
